export const SPAN_ENVIRONMENT_VALUES = [
	'STREET',
	'HIGHWAY',
	'PEDESTRIAN',
	'PARALLEL_TO_STREET',
	'UNLIKELY_PARALLEL_TO_STREET',
	'DRIVEWAY / VEHICLE ACCESS',
	'ALLEY',
	'RAILROAD',
	'RURAL',
	'FARM',
	'WATER_WITH SAILBOATS',
	'WATER_WITHOUT_SAILBOATS',
] as const;
